<template>
  <div class="layout-empty">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "LayoutEmpty"
};
</script>
